// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.blog-page {
    /* background: #FFFFFF; */
    padding: 2rem 0;
}

.blog-page > .title {
    margin: 16px 0;
    text-align: center;
    font-size: 1.5rem;
    font-weight: 700;
    color: #B54708;
    text-align: center;
}

.blog-page > .content {
    display: flex;
    gap: 50px;
}

.blog-page .left-side {
    flex: 1 1;
}

.blog-content {
    background: #FFF;
    padding: 1.5rem;
    margin-bottom: 1rem;
    border-radius: 10px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
}

.blog-content:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
}

.blog-content img {
    width: 100%;
    border-radius: 10px;
    margin-bottom: 1rem;
}

.blog-content .subtext {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 0.8rem;
    color: #999999;
}

.blog-content .title {
    padding: 15px 0;
    font-size: 1.6rem;
    font-weight: 600;
    color: #DC6803;
}

.blog-content .content {
    font-size: 0.9rem;
    color: #444444;
    line-height: 1.6;
    padding-bottom: 20px;
    border-bottom: 1px solid #E6E6E6;
}

.blog-content .blog-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 10px;
}

.blog-content .blog-footer .categ {
    font-size: 0.8rem;
    font-weight: 400;
    color: #666;
}

.blog-content .blog-footer .categ span {
    color: #F09300;
}

.blog-content .blog-footer .readmore {
    font-size: 0.8rem;
    font-weight: 600;
}

.blog-page .right-side {
    display: flex;
    flex-direction: column;
    gap: 30px;
    flex: 0 0 25%;
    justify-content: flex-start;
}

.blog-page .right-side .Categories .MuiCardContent-root {
    display: flex;
    flex-direction: column;
    gap: 30px;
}

.blog-page .right-side .categ {
    display: flex;
    flex-direction: row;
    gap: 10px;
    cursor: pointer;
}

.blog-page .right-side .categ .text {
    color: #444444;
    font-size: 0.8rem;
    font-weight: 400;
}

.blog-page .right-side .recent-posts .MuiCardContent-root {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.blog-page .right-side .recent-posts .post-card {
    display: flex;
    gap: 5px;
    height: 11vh;
}

.blog-page .right-side .recent-posts .post-card img {
    flex: 2 1;
    width: 7rem;
    border-radius: 5px;
}

.blog-page .right-side .recent-posts .post-card .text {
    flex: 5 1;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
}

.blog-page .right-side .recent-posts .post-card .post-title {
    font-size: 1rem;
    font-weight: 600;
    color: #DC6803;
    display: -webkit-box;
    -webkit-line-clamp: 2; /* Number of lines to display */
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    
}

.blog-page .right-side .recent-posts .post-card .post-date {
    font-size: 0.8rem;
    color: #636363;
    font-weight: normal;

}

.blog-page .right-side .tags .MuiCardContent-root {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
    flex-direction: row;
    font-size: 1rem;
}

.pagination {
    display: flex;
    justify-content: center;
    margin: 1.5rem 0;
}

.pagination .MuiPagination-ul {
    color: #667085 !important;
}

.pagination li:nth-child(n+2):nth-last-child(n+2) button {
    color: #667085;
}

.pagination li:first-child button,
.pagination li:last-child button {
    font-family: 'Sora', sans-serif;
    line-height: 20px;
    font-weight: 500;
    color: #344054;
    border: 1px solid #D0D5DD;
    gap: 10px;
}

.pagination li:first-child {
    position: absolute;
    left: 13lvw;
}

.pagination li:last-child {
    position: absolute;
    right: 13lvw;
}

.pagination .Mui-selected {
    background-color: #FCCC4D !important;
    color: #7F56D9 !important;
    font-weight: bold;
    border-radius: 50%;
}



.selected-blog-img-section {
    padding: 10px 0;
    max-width: 1320px;
    display: flex;
    justify-content: center;
    position: relative; /* To allow overlap positioning */
    z-index: 1; /* Ensure the image remains behind the content */
}

.selected-blog-img-section img {
    width: 100%;
    aspect-ratio: 2/1;
}

.selected-blog-content-section {
    background: #ffffff;
    border-radius: 16px;
    padding: 5%;
    border: 1px solid #E7E7E7;
    box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.08);
    margin: -20% auto 24px; /* Negative margin to overlap the image */
    z-index: 2; /* Ensure it overlaps the image */
    position: relative; /* Keep it positioned above the image */
}


.selected-blog-content-section::before {
    content: "";
    position: absolute;
    top: -20px;
    left: 0;
    right: 0;
    height: 20px;
    background: rgba(0, 0, 0, 0.05);
    z-index: -1;
}
.selected-blog-content-section > .blog-cat {
    display: inline-flex;
    background: #f09300;
    padding: 5px;
    width: 10vw;
    justify-content: center;
    font-size: 0.8rem;
    color: #000000;
    line-height: 20px;
}
.selected-blog-content-section > .blog-subtext {
    display: flex;
    justify-content: space-between;
    color: #999999;
    font-size: 0.8rem;
    line-height: 20px;
}

.selected-blog-content-section .views {
    display: flex;
    gap: 2px;
}

.blog-title-section {
    padding: 10px 0;
    display: flex;
    justify-content: space-between;
}

.blog-title-section>.blog-title {
    font-size: 2.2rem;
    font-weight: 700;
    line-height: 44px;
    letter-spacing: -2px;
}

.blog-title-section button {
    cursor: pointer;
    padding: 0 15px;
    border: none;
    border-radius: 80px;
    color: #ffffff;
    font-weight: 700;
    font-size: 0.8rem;
    line-height: 44px;
}

.blog-play-title {
    display: inline-flex;
    gap: 10px;
    align-items: center;
}


.selected-blog-content-section .author {
    text-align: end;
    font-weight: 600;
}

@media (max-width: 768px) {
    .blog-page > .content {
        flex-direction: column-reverse;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/blog/blog.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,mBAAmB;IACnB,yCAAyC;IACzC,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,0CAA0C;AAC9C;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,oBAAoB;IACpB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,aAAa;IACb,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,SAAO;IACP,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,oBAAoB;IACpB,qBAAqB,EAAE,+BAA+B;IACtD,4BAA4B;IAC5B,gBAAgB;IAChB,uBAAuB;;AAE3B;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,mBAAmB;;AAEvB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,+BAA+B;IAC/B,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;AACtB;;;;AAIA;IACI,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,uBAAuB;IACvB,kBAAkB,EAAE,iCAAiC;IACrD,UAAU,EAAE,gDAAgD;AAChE;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,yBAAyB;IACzB,4CAA4C;IAC5C,sBAAsB,EAAE,yCAAyC;IACjE,UAAU,EAAE,iCAAiC;IAC7C,kBAAkB,EAAE,uCAAuC;AAC/D;;;AAGA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,+BAA+B;IAC/B,WAAW;AACf;AACA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,uBAAuB;IACvB,iBAAiB;IACjB,cAAc;IACd,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;IACpB,SAAS;IACT,mBAAmB;AACvB;;;AAGA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI;QACI,8BAA8B;IAClC;AACJ","sourcesContent":[".blog-page {\n    /* background: #FFFFFF; */\n    padding: 2rem 0;\n}\n\n.blog-page > .title {\n    margin: 16px 0;\n    text-align: center;\n    font-size: 1.5rem;\n    font-weight: 700;\n    color: #B54708;\n    text-align: center;\n}\n\n.blog-page > .content {\n    display: flex;\n    gap: 50px;\n}\n\n.blog-page .left-side {\n    flex: 1;\n}\n\n.blog-content {\n    background: #FFF;\n    padding: 1.5rem;\n    margin-bottom: 1rem;\n    border-radius: 10px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n    transition: all 0.3s ease;\n}\n\n.blog-content:hover {\n    transform: translateY(-4px);\n    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);\n}\n\n.blog-content img {\n    width: 100%;\n    border-radius: 10px;\n    margin-bottom: 1rem;\n}\n\n.blog-content .subtext {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    font-size: 0.8rem;\n    color: #999999;\n}\n\n.blog-content .title {\n    padding: 15px 0;\n    font-size: 1.6rem;\n    font-weight: 600;\n    color: #DC6803;\n}\n\n.blog-content .content {\n    font-size: 0.9rem;\n    color: #444444;\n    line-height: 1.6;\n    padding-bottom: 20px;\n    border-bottom: 1px solid #E6E6E6;\n}\n\n.blog-content .blog-footer {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding-top: 10px;\n}\n\n.blog-content .blog-footer .categ {\n    font-size: 0.8rem;\n    font-weight: 400;\n    color: #666;\n}\n\n.blog-content .blog-footer .categ span {\n    color: #F09300;\n}\n\n.blog-content .blog-footer .readmore {\n    font-size: 0.8rem;\n    font-weight: 600;\n}\n\n.blog-page .right-side {\n    display: flex;\n    flex-direction: column;\n    gap: 30px;\n    flex: 0 0 25%;\n    justify-content: flex-start;\n}\n\n.blog-page .right-side .Categories .MuiCardContent-root {\n    display: flex;\n    flex-direction: column;\n    gap: 30px;\n}\n\n.blog-page .right-side .categ {\n    display: flex;\n    flex-direction: row;\n    gap: 10px;\n    cursor: pointer;\n}\n\n.blog-page .right-side .categ .text {\n    color: #444444;\n    font-size: 0.8rem;\n    font-weight: 400;\n}\n\n.blog-page .right-side .recent-posts .MuiCardContent-root {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.blog-page .right-side .recent-posts .post-card {\n    display: flex;\n    gap: 5px;\n    height: 11vh;\n}\n\n.blog-page .right-side .recent-posts .post-card img {\n    flex: 2;\n    width: 7rem;\n    border-radius: 5px;\n}\n\n.blog-page .right-side .recent-posts .post-card .text {\n    flex: 5;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-evenly;\n}\n\n.blog-page .right-side .recent-posts .post-card .post-title {\n    font-size: 1rem;\n    font-weight: 600;\n    color: #DC6803;\n    display: -webkit-box;\n    -webkit-line-clamp: 2; /* Number of lines to display */\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    \n}\n\n.blog-page .right-side .recent-posts .post-card .post-date {\n    font-size: 0.8rem;\n    color: #636363;\n    font-weight: normal;\n\n}\n\n.blog-page .right-side .tags .MuiCardContent-root {\n    display: flex;\n    gap: 10px;\n    flex-wrap: wrap;\n    flex-direction: row;\n    font-size: 1rem;\n}\n\n.pagination {\n    display: flex;\n    justify-content: center;\n    margin: 1.5rem 0;\n}\n\n.pagination .MuiPagination-ul {\n    color: #667085 !important;\n}\n\n.pagination li:nth-child(n+2):nth-last-child(n+2) button {\n    color: #667085;\n}\n\n.pagination li:first-child button,\n.pagination li:last-child button {\n    font-family: 'Sora', sans-serif;\n    line-height: 20px;\n    font-weight: 500;\n    color: #344054;\n    border: 1px solid #D0D5DD;\n    gap: 10px;\n}\n\n.pagination li:first-child {\n    position: absolute;\n    left: 13lvw;\n}\n\n.pagination li:last-child {\n    position: absolute;\n    right: 13lvw;\n}\n\n.pagination .Mui-selected {\n    background-color: #FCCC4D !important;\n    color: #7F56D9 !important;\n    font-weight: bold;\n    border-radius: 50%;\n}\n\n\n\n.selected-blog-img-section {\n    padding: 10px 0;\n    max-width: 1320px;\n    display: flex;\n    justify-content: center;\n    position: relative; /* To allow overlap positioning */\n    z-index: 1; /* Ensure the image remains behind the content */\n}\n\n.selected-blog-img-section img {\n    width: 100%;\n    aspect-ratio: 2/1;\n}\n\n.selected-blog-content-section {\n    background: #ffffff;\n    border-radius: 16px;\n    padding: 5%;\n    border: 1px solid #E7E7E7;\n    box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.08);\n    margin: -20% auto 24px; /* Negative margin to overlap the image */\n    z-index: 2; /* Ensure it overlaps the image */\n    position: relative; /* Keep it positioned above the image */\n}\n\n\n.selected-blog-content-section::before {\n    content: \"\";\n    position: absolute;\n    top: -20px;\n    left: 0;\n    right: 0;\n    height: 20px;\n    background: rgba(0, 0, 0, 0.05);\n    z-index: -1;\n}\n.selected-blog-content-section > .blog-cat {\n    display: inline-flex;\n    background: #f09300;\n    padding: 5px;\n    width: 10vw;\n    justify-content: center;\n    font-size: 0.8rem;\n    color: #000000;\n    line-height: 20px;\n}\n.selected-blog-content-section > .blog-subtext {\n    display: flex;\n    justify-content: space-between;\n    color: #999999;\n    font-size: 0.8rem;\n    line-height: 20px;\n}\n\n.selected-blog-content-section .views {\n    display: flex;\n    gap: 2px;\n}\n\n.blog-title-section {\n    padding: 10px 0;\n    display: flex;\n    justify-content: space-between;\n}\n\n.blog-title-section>.blog-title {\n    font-size: 2.2rem;\n    font-weight: 700;\n    line-height: 44px;\n    letter-spacing: -2px;\n}\n\n.blog-title-section button {\n    cursor: pointer;\n    padding: 0 15px;\n    border: none;\n    border-radius: 80px;\n    color: #ffffff;\n    font-weight: 700;\n    font-size: 0.8rem;\n    line-height: 44px;\n}\n\n.blog-play-title {\n    display: inline-flex;\n    gap: 10px;\n    align-items: center;\n}\n\n\n.selected-blog-content-section .author {\n    text-align: end;\n    font-weight: 600;\n}\n\n@media (max-width: 768px) {\n    .blog-page > .content {\n        flex-direction: column-reverse;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
